import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'

import user from './user/UserReducer'
import datas from './datas/DatasReducer'
import provider from './provider/ProviderReducer'
import notification from './notification/NotificationReducer'
import lead from './lead/LeadReducer'

const combinedReducer = combineReducers({
    form,
    user,
    datas,
    provider,
    notification,
    lead,
})

const rootReducer = (state, action) => {
	if (action.type === 'LOGOUT_USER') {
    	state = undefined
  	}

    return combinedReducer(state, action)
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducer.js